module.exports = __webpack_public_path__ + "static/q15-7fad4fb51681b13bddcc0ffcb4cea490.png";